// Material Kit 2 React pages
import SisterConcern from "pages/SisterConcern";

export default function SisterConcerns() {
  return <SisterConcern />;
}
